var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a9c9dc43-ec2d-4c57-814f-6893c8cf5622",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "aafb2488-2442-4a20-be21-626489d043a4",
    "data-name": "Path 65",
    d: "M10.74,9.694V7.157a.74.74,0,1,0-1.479,0V10a.748.748,0,0,0,.217.523l2.17,2.171a.739.739,0,0,0,1.046-1.045Z",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f317acf8-f4c8-42d3-bef2-5ab54227ea8d",
    "data-name": "Path 66",
    d: "M10,3.119A6.881,6.881,0,1,0,16.881,10h0A6.889,6.889,0,0,0,10,3.119M10,15.4A5.4,5.4,0,1,1,15.4,10h0A5.409,5.409,0,0,1,10,15.4",
    style: {
      fill: "#005a7d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxClock);
export default __webpack_public_path__ + "static/media/bxClock.1b217cb51e70a8cbd3b92a07009b1feb.svg";
export { ForwardRef as ReactComponent };